/**
 * @generated SignedSource<<f0688f7e431ddc63994db6a71faf7973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type naturalLanguageToJqlWrapper_jqlBuilderWithAi$data = {
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilderEmbedded_jqlBuilderWithAi">;
  readonly " $fragmentType": "naturalLanguageToJqlWrapper_jqlBuilderWithAi";
};
export type naturalLanguageToJqlWrapper_jqlBuilderWithAi$key = {
  readonly " $data"?: naturalLanguageToJqlWrapper_jqlBuilderWithAi$data;
  readonly " $fragmentSpreads": FragmentRefs<"naturalLanguageToJqlWrapper_jqlBuilderWithAi">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "jqlBuilderEmbedded_jqlBuilderWithAi"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "7bd16e68fc1878ae6b8f7e375bf28056";

export default node;
